import React from 'react';
import { Printer } from 'lucide-react';
import { Button } from '../components/ui/Button';
import { Card } from '../components/ui/Card';
import { Link } from 'react-router-dom';
export function OrderSearch() {
  const orders = [{
    id: 1001,
    orderNumber: 'ORD-2023-001',
    products: 'Desert Ecology Basics',
    subtotal: '$49.00',
    status: 'Processed',
    customer: 'John Doe',
    date: '2023-10-15',
    total: '$49.00'
  }, {
    id: 1002,
    orderNumber: 'ORD-2023-002',
    products: 'Advanced Water Conservation',
    subtotal: '$79.00',
    status: 'Failed',
    customer: 'Alice Smith',
    date: '2023-10-16',
    total: '$79.00'
  }, {
    id: 1003,
    orderNumber: 'ORD-2023-003',
    products: 'Sustainable Landscaping',
    subtotal: '$39.00',
    status: 'Not Finished',
    customer: 'Bob Wilson',
    date: '2023-10-17',
    total: '$39.00'
  }];
  return <div className="space-y-4" data-id="element-1354" data-mp="3rz39r78q7shl">
      <h1 className="text-2xl font-bold text-slate-900" data-id="element-1355" data-mp="2q5qpnvf812e1">Order Search</h1>

      <div className="space-y-2" data-id="element-1356" data-mp="2q7l9f6eraogj">
        <div data-id="element-1357" data-mp="2v3it9mp8acy2">
          <label className="block text-xs text-slate-600 mb-0.5" data-id="element-1358" data-mp="2v3abphi5ujgj">Date</label>
          <select className="h-8 rounded border border-slate-300 bg-white px-2 text-sm focus:outline-none focus:ring-2 focus:ring-slate-400 min-w-[120px]" data-id="element-1359" data-mp="302vgi8k0hm16">
            <option data-id="element-1360" data-mp="350f25tj1h135">Today</option>
            <option data-id="element-1361" data-mp="27ezgouz5be06">All Dates</option>
            <option data-id="element-1362" data-mp="27g2d1if8m8nh">This Week</option>
            <option data-id="element-1363" data-mp="27cwkft7egon0">This Month</option>
          </select>
        </div>
        <div data-id="element-1364" data-mp="2cec8zv8sdda5">
          <label className="block text-xs text-slate-600 mb-0.5" data-id="element-1365" data-mp="2cbq0nte2mtqv">Coupon</label>
          <select className="h-8 rounded border border-slate-300 bg-white px-2 text-sm focus:outline-none focus:ring-2 focus:ring-slate-400 min-w-[120px]" data-id="element-1366" data-mp="2hbcdw2twg9zo">
            <option data-id="element-1367" data-mp="1oorkyxxrzpu0">&lt;Ignore&gt;</option>
            <option data-id="element-1368" data-mp="1onq7kmtaer94">SUMMER23</option>
            <option data-id="element-1369" data-mp="1tnclkygxwbiz">WELCOME</option>
          </select>
        </div>
        <div data-id="element-1370" data-mp="1tli1fmdhsnfy">
          <label className="block text-xs text-slate-600 mb-0.5" data-id="element-1371" data-mp="1tl8c8109ukbb">
            Reseller
          </label>
          <select className="h-8 rounded border border-slate-300 bg-white px-2 text-sm focus:outline-none focus:ring-2 focus:ring-slate-400 min-w-[120px]" data-id="element-1372" data-mp="1lkaedxc0aj36">
            <option data-id="element-1373" data-mp="1vb50n1p95iom">&lt;Ignore&gt;</option>
            <option data-id="element-1374" data-mp="1veaoyeq24gja">Partner A</option>
          </select>
        </div>
        <div data-id="element-1375" data-mp="1qdvdjspc5j3y">
          <Button size="sm" variant="secondary" className="border border-slate-300 bg-gradient-to-b from-white to-slate-100 text-slate-700 shadow-sm" data-id="element-1376" data-mp="1qfg8hjfkb42c">
            Search
          </Button>
        </div>
      </div>

      {orders.length === 0 ? <p className="text-sm text-slate-600" data-id="element-1377" data-mp="1cn9ua2vyz75j">No Record Found</p> : <Card className="overflow-hidden rounded-none border-slate-300" data-id="element-1378" data-mp="17m2m42px05yc">
          <div className="overflow-x-auto" data-id="element-1379" data-mp="2o0c9oumc1qo4">
            <table className="w-full text-sm text-left" data-id="element-1380" data-mp="2nzanpv3s3jrm">
              <thead className="bg-slate-800 text-white font-medium" data-id="element-1381" data-mp="2j2tw2qxden9s">
                <tr data-id="element-1382" data-mp="2qljpva3p89nz">
                  <th className="px-3 py-3 border-r border-slate-700 w-8" data-id="element-1383" data-mp="2qla9me8ghgvh">
                    <input type="checkbox" className="rounded border-slate-500" data-id="element-1384" data-mp="2vkmvowri6jx0" />
                  </th>
                  <th className="px-3 py-3 border-r border-slate-700" data-id="element-1385" data-mp="2hmohpsh3gpi1">
                    Order Number
                  </th>
                  <th className="px-3 py-3 border-r border-slate-700" data-id="element-1386" data-mp="39c1d4z5rid1y">
                    Products
                  </th>
                  <th className="px-3 py-3 border-r border-slate-700 text-center w-20" data-id="element-1387" data-mp="3ebnv1lwjchh3">
                    Subtotal
                  </th>
                  <th className="px-3 py-3 border-r border-slate-700 w-28" data-id="element-1388" data-mp="30j7tyqn72tit">
                    Status
                  </th>
                  <th className="px-3 py-3 border-r border-slate-700" data-id="element-1389" data-mp="34iyj6px2p1l8">
                    Customer Name
                  </th>
                  <th className="px-3 py-3 border-r border-slate-700 text-center w-24" data-id="element-1390" data-mp="wri2b0ai83o">
                    Date
                  </th>
                  <th className="px-3 py-3 border-r border-slate-700 text-center w-20" data-id="element-1391" data-mp="29evjrh5ynizh">
                    Total
                  </th>
                  <th className="px-3 py-3 text-center w-28" data-id="element-1392" data-mp="1zf4nb9xuatwr">Action</th>
                </tr>
              </thead>
              <tbody className="divide-y divide-slate-200" data-id="element-1393" data-mp="1vdsvqyvenylx">
                {orders.map(order => <tr key={order.id} className="hover:bg-slate-50" data-id="element-1394" data-mp="2s3ijrl9a5i67">
                    <td className="px-3 py-2.5 border-r border-slate-200" data-id="element-1395" data-mp="2s5wic4365cii">
                      <input type="checkbox" className="rounded border-slate-300" data-id="element-1396" data-mp="2n58prdzaknm6" />
                    </td>
                    <td className="px-3 py-2.5 border-r border-slate-200" data-id="element-1397" data-mp="2ebc8ach2nzd3">
                      {order.orderNumber}
                    </td>
                    <td className="px-3 py-2.5 border-r border-slate-200" data-id="element-1398" data-mp="3awe2hk9xqzs9">
                      {order.products}
                    </td>
                    <td className="px-3 py-2.5 border-r border-slate-200 text-center" data-id="element-1399" data-mp="slgongb4lhsq">
                      {order.subtotal}
                    </td>
                    <td className="px-3 py-2.5 border-r border-slate-200" data-id="element-1400" data-mp="xm4alnkhz8g3">
                      <select defaultValue={order.status} className="h-7 text-xs rounded border border-slate-300 bg-white px-1 focus:outline-none focus:ring-1 focus:ring-slate-400 w-full" data-id="element-1401" data-mp="11ktywb72qaei">
                        <option data-id="element-1402" data-mp="1gim86lm122k9">Failed</option>
                        <option data-id="element-1403" data-mp="1ghb7wvrsjcxw">Processed</option>
                        <option data-id="element-1404" data-mp="1l9uhlhncxnxf">Not Finished</option>
                      </select>
                    </td>
                    <td className="px-3 py-2.5 border-r border-slate-200" data-id="element-1405" data-mp="1pbpjood445c9">
                      {order.customer}
                    </td>
                    <td className="px-3 py-2.5 border-r border-slate-200 text-center" data-id="element-1406" data-mp="1ubu3ood8bi78">
                      {order.date}
                    </td>
                    <td className="px-3 py-2.5 border-r border-slate-200 text-center font-medium" data-id="element-1407" data-mp="3vc8ply2l50by">
                      {order.total}
                    </td>
                    <td className="px-3 py-2.5 text-center" data-id="element-1408" data-mp="3qf8irkxwvtjs">
                      <Link to={`/custom/orders/print_order/${order.id}`} target="_blank" data-id="element-1409" data-mp="8x7b2tntumsa">
                        <button title="Print Order" className="p-1 text-slate-500 hover:text-blue-600" data-id="element-1410" data-mp="hxlvzrwvpzv9">
                          <Printer className="h-4 w-4" data-id="element-1411" data-mp="dy39irpetgqb" />
                        </button>
                      </Link>
                    </td>
                  </tr>)}
              </tbody>
            </table>
          </div>
        </Card>}
    </div>;
}